import * as React from 'react';

export type InlineFeedbackRubricContextType = {
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
  isReadOnly: boolean; // allows annotations and autosave when false
};

export const InlineFeedbackRubricContext = React.createContext({} as InlineFeedbackRubricContextType);
